import { z } from 'zod';
import { transformAndFilterValidEdges } from '../../../common/tools/transformEdgesUtils';
import { BaseResourceLibraryItemSchema } from './resourceLibraryBaseZodSchemas';
import { ImageSchema } from '../../../common/schemas/imageZodSchemas';

export const ResourceLibraryNewsBaseItemSchema = BaseResourceLibraryItemSchema.extend({
    coverImage: ImageSchema.nullable(),
}).describe('ResourceLibraryNewsBaseItemSchema');

export const ResourceLibraryNewsItemSchema = ResourceLibraryNewsBaseItemSchema.extend({
    body: z.string().nullable(),
}).describe('ResourceLibraryNewsItemSchema');

// Listing query returns basse news items (without 'body' field)
export const GetResourceLibraryNewsItemListingSchema = z
    .object({
        getResourceLibraryNewsItemListing: z.object({
            edges: z
                .array(
                    z.object({
                        node: z.unknown(),
                    })
                )
                .transform((edges) =>
                    transformAndFilterValidEdges(ResourceLibraryNewsBaseItemSchema, edges)
                ),
        }),
    })
    .describe('GetResourceLibraryNewsItemListingSchema');

// Single item query returns full news items (with 'body' field)
export const GetResourceLibraryNewsItemSchema = z
    .object({
        getResourceLibraryNewsItem: ResourceLibraryNewsItemSchema,
    })
    .describe('GetResourceLibraryNewsItemSchema');
